import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NotesComponent } from './notes.component';
import { NoteMainComponent } from './note-main/note-main.component';
import { NoteExampleComponent } from './note-example/note-example.component';
import { NoteCompactV2Component } from './note-compact-v2/note-compact-v2.component';

const routes: Routes = [{
  path: '', component: NotesComponent,
  children: [
    { path: 'viewer', component: NoteMainComponent },
    { path: 'example', component: NoteExampleComponent },
    { path: 'compactv2', component: NoteCompactV2Component },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotesRoutingModule { }
